import { useSelector } from "react-redux";

import { CircularLoader } from "@similarweb/ui-components";

import { selectMetricByName } from "app/pages/benchmark-tracker/store/selectors/reportSelectors";
import type { RankingDataSchema } from "app/pages/benchmark-tracker/types/api.types";

import type { ComponentSchema } from "../../Tab/types";

import RankingHeader from "./RankingHeader/RankingHeader";
import { LoaderWrapper, Wrapper } from "./styles";
import WidgetChart from "./WidgetChart/WidgetChart";

const RankingWidget = ({ format, tooltip, title, name, onOpenModal, setMetricOptions }: ComponentSchema) => {
    const data = useSelector(selectMetricByName<RankingDataSchema>(name));

    const isLoading = data?.isLoading;
    const isInverted = data?.metricConfig?.isInverse;
    const isRelative = data?.metricConfig?.isRelative;

    const handleOpenModal = () => {
        setMetricOptions?.({ isRelative: isRelative ?? false, isInverted: isInverted ?? false });
        onOpenModal?.(name);
    };

    if (!data) {
        return null;
    }

    return (
        <Wrapper>
            <RankingHeader
                data={data}
                format={format}
                tooltip={tooltip ?? ""}
                title={title}
                isInverted={isInverted ?? false}
                isLoading={isLoading ?? false}
                isRelative={isRelative}
            />
            <div>
                {isLoading ? (
                    <LoaderWrapper>
                        <CircularLoader isLarge />
                    </LoaderWrapper>
                ) : (
                    <WidgetChart
                        format={format}
                        data={data}
                        isInverted={isInverted ?? false}
                        name={name}
                        onOpenModal={handleOpenModal}
                        isRelative={isRelative}
                    />
                )}
            </div>
        </Wrapper>
    );
};

export default RankingWidget;
